import { AnalysisValue, BodyScanTypes, IBodyScanAnalysisData, IBodyScanData } from 'fitbeat.models';

export class BodyScanSerializer {
    // format ex "2019-08-22 16:36:04" so the first 10 chars are iso format
    public static convertStringToDate(testTime: string): Date {
      if (testTime == null || testTime.length < 11) {
          return new Date(0);
      }
      try {
          const timeIsoDateOnly = testTime.slice(0, 10);
          const date = new Date(timeIsoDateOnly);
          return date;
      } catch (error) {
          return new Date(0);
      }
  }

  public static buildAnalyticData(bodyScan: any): IBodyScanData {
    const analysisItems = bodyScan.analysis.items;
    const bodyScanData: IBodyScanData = {
      id: bodyScan._id,
      dateOfScan: bodyScan.testTime,
      dateOfScanDateOnly: BodyScanSerializer.convertStringToDate(bodyScan.testTime),
      testTime: bodyScan.testTime,
      email: bodyScan.userEmail,
      analysis: {
        score: BodyScanSerializer.buildScoreData(bodyScan.score),
        percentBodyFat: BodyScanSerializer.analysisMetrics(analysisItems, 'PBF'),
        bodyMassIndex: BodyScanSerializer.analysisMetrics(analysisItems, 'BMI'),
        weight: BodyScanSerializer.buildWeightData(analysisItems, 'WT'),
        waistHipRatio: BodyScanSerializer.analysisMetrics(analysisItems, 'WHR'),
        skeletalMuscleMass: BodyScanSerializer.analysisMetrics(analysisItems, 'SMM'),
        obesityDegree: BodyScanSerializer.analysisMetrics(analysisItems, 'OD'),
      },
      invalid: bodyScan.invalid,
      type: BodyScanSerializer.getBodyScanType(bodyScan),
      target: bodyScan.target,
      milestone: bodyScan.milestone,
      weight: bodyScan.weight,
      calculatedBodyFat: bodyScan.calculatedBodyFat,
      calculatedMuscleMassMeterKg: bodyScan.calculatedMuscleMassMeterKg,
      rawBodyFat: bodyScan.rawScan ? bodyScan.rawScan.bodyFatRate : 0,
    };

    return bodyScanData;
  }

  public static analysisMetrics(analysisItems: any, metric: string): IBodyScanAnalysisData | undefined {
    const analysisItem = BodyScanSerializer.findAnalysisItem(analysisItems, metric);
    if (!BodyScanSerializer.isAnalysisItemValid(analysisItem)) {
      return undefined;
    }

    return {
      currentValue: parseFloat(analysisItem.value[AnalysisValue.Current]),
      lowerLimitValue: parseFloat(analysisItem.value[AnalysisValue.LowerLimit]),
      upperLimitValue: parseFloat(analysisItem.value[AnalysisValue.UpperLimit]),
    };
  }

  public static buildScoreData(score: string): IBodyScanAnalysisData | undefined {
    if (!score) {
      return undefined;
    }

    return {
      currentValue: parseFloat(score),
      lowerLimitValue: 100,
      upperLimitValue: 100,
    };
  }

  public static buildWeightData(analysisItems: any, weight: string): IBodyScanAnalysisData | undefined {
    const analysisItem = BodyScanSerializer.findAnalysisItem(analysisItems, weight);
    if (!BodyScanSerializer.isAnalysisItemValid(analysisItem)) {
      return undefined;
    }

    const target = parseFloat(analysisItem.value[AnalysisValue.Target]);
    return {
      currentValue: parseFloat(analysisItem.value[AnalysisValue.Current]),
      lowerLimitValue: target,
      upperLimitValue: target,
    };
  }

  public static findAnalysisItem(analysisItems: any, metric: string): any {
    return analysisItems.find((metricItem: any) => metricItem.itemID === metric);
  }

  public static isAnalysisItemValid(analysisItem: any): boolean {
    if (!analysisItem || analysisItem.value === undefined) {
      return false;
    }

    return analysisItem.value.length === 4;
  }

  private static getBodyScanType(bodyScan: any): BodyScanTypes {
    if (bodyScan.isManualWeightLog) {
      return BodyScanTypes.Manual;
    } else if (bodyScan.isLeaone) {
      return BodyScanTypes.Leaone;
    }
    return BodyScanTypes.Tiger;
  }
}
